<form [formGroup]="checkboxFormGroup" [glPremium]="true">
  <label for="checkbox" class="checkboxLabel" [ngClass]="{'on': checkboxFormGroup.get(controlName).value}">
    <button outline-icon-button class="checkboxButton">
      <gl-icon [name]="iconName"></gl-icon>
    </button>
    @if (tooltipInfo) {
      <div class="info" [glTooltip]="tooltipInfo">i</div>
    }
    <input
      type="checkbox"
      id="checkbox"
      [formControlName]="controlName"
      class="checkboxInput"
      />
  </label>
</form>
